export const c_form_control_m_icon_sprite_success_BackgroundUrl = {
  "name": "--pf-c-form-control--m-icon-sprite--success--BackgroundUrl",
  "value": "url(\"../../assets/images/status-icon-sprite.svg#success\")",
  "var": "var(--pf-c-form-control--m-icon-sprite--success--BackgroundUrl)"
};
export default c_form_control_m_icon_sprite_success_BackgroundUrl;